import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import VehicleTypesListResults from '../../components/vehicle-types/VehicleTypesListResults';
import VehicleTypesToolBar from '../../components/vehicle-types/VehicleTypesToolBar';
import {
  getVehicleTypesList,
  removeVehicleType,
} from '../../redux/vehicle-types/action';

const VehicleTypes = () => {
  const dispatch = useDispatch();
  const [vehicles, setVehicles] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [vehicleTypeID, setVehicleTypeID] = useState();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    setLoading(true);
    dispatch(getVehicleTypesList()).then((data) => {
      setVehicles(data);
      setLoading(false);
    });
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleRow = async (id) => {
    handleOpen(true);
    setVehicleTypeID(id);
  };

  const handleRemove = async () => {
    setOpen(false);
    setLoading(true);
    await dispatch(removeVehicleType(vehicleTypeID));
    const data = await dispatch(getVehicleTypesList());
    setVehicles(data);
    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>VEHICLE TYPES</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <VehicleTypesToolBar />
          <Box sx={{ pt: 3 }}>
            <VehicleTypesListResults
              vehicles={vehicles}
              handleRow={handleRow}
              loading={loading}
            />
          </Box>
          <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to remove it?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Disagree
              </Button>
              <Button onClick={handleRemove} color="primary" autoFocus>
                Agree
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    </>
  );
};

export default VehicleTypes;
